export class Node<T> {
    value: T;
    nodes: Node<T>[];

    constructor(value: T) {
        this.nodes = new Array<Node<T>>();
        this.value = value;
    }
}